import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

// Navegación lateral por perfil. Recibe `sections` de navConfig.js:
// grupos colapsables con auto-apertura de la ruta activa, buscador de
// opciones y cierre de sesión separado al final.

const normalizar = (s) =>
  String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');

const SideNav = ({ sections = [] }) => {
  const history = useHistory();
  const location = useLocation();

  const [filtro, setFiltro] = useState('');
  const [abiertos, setAbiertos] = useState({});

  const cerrarSession = (e) => {
    e.preventDefault();
    localStorage.removeItem('dataUser');
    history.push('/');
  };

  const coincide = (item) =>
    !filtro || normalizar(item.label).indexOf(normalizar(filtro)) !== -1;

  const contieneActiva = (sec) =>
    sec.items.some((i) => i.to === location.pathname);

  const estaAbierto = (sec) => {
    if (filtro) return true;
    if (abiertos[sec.key] != null) return abiertos[sec.key];
    return contieneActiva(sec);
  };

  const alternarGrupo = (sec) => {
    setAbiertos({ ...abiertos, [sec.key]: !estaAbierto(sec) });
  };

  const renderItem = (item) => {
    const activo = item.to === location.pathname;
    return (
      <li key={item.to + item.label}>
        <Link
          to={item.to}
          className={activo ? 'esen-nav-link esen-nav-link--active' : 'esen-nav-link'}
          aria-current={activo ? 'page' : undefined}
        >
          <span className={`fa ${item.icon}`} aria-hidden="true"></span>
          <span className="esen-nav-label">{item.label}</span>
        </Link>
      </li>
    );
  };

  return (
    <nav className="esen-nav" aria-label="Menú principal">
      <div className="esen-nav-search">
        <span className="fa fa-search" aria-hidden="true"></span>
        <input
          type="search"
          placeholder="Buscar en el menú…"
          aria-label="Buscar en el menú"
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
        />
        {filtro ? (
          <button
            type="button"
            aria-label="Limpiar búsqueda"
            onClick={() => setFiltro('')}
          >
            <span className="fa fa-times" aria-hidden="true"></span>
          </button>
        ) : null}
      </div>

      {sections.map((sec, idx) => {
        const visibles = sec.items.filter(coincide);
        if (!visibles.length) return null;

        // Sección plana
        if (!sec.label) {
          return (
            <ul className="esen-nav-list" key={`flat-${idx}`}>
              {visibles.map(renderItem)}
            </ul>
          );
        }

        // Grupo colapsable
        const abierto = estaAbierto(sec);
        return (
          <div
            className={abierto ? 'esen-nav-group esen-nav-group--open' : 'esen-nav-group'}
            key={sec.key}
          >
            <button
              type="button"
              className="esen-nav-grouphead"
              onClick={() => alternarGrupo(sec)}
              aria-expanded={abierto}
            >
              <span className={`fa ${sec.icon}`} aria-hidden="true"></span>
              <span className="esen-nav-label">{sec.label}</span>
              <span className="fa fa-chevron-down esen-nav-chevron" aria-hidden="true"></span>
            </button>
            <div className="esen-nav-groupbody">
              <div>
                <ul className="esen-nav-list">
                  {visibles.map(renderItem)}
                </ul>
              </div>
            </div>
          </div>
        );
      })}

      {filtro && !sections.some((s) => s.items.some(coincide)) ? (
        <p className="esen-nav-noresult">Sin resultados para “{filtro}”</p>
      ) : null}

      <div className="esen-nav-footer">
        <a href="/" className="esen-nav-link esen-nav-link--logout" onClick={cerrarSession}>
          <span className="fa fa-sign-out" aria-hidden="true"></span>
          <span className="esen-nav-label">Cerrar sesión</span>
        </a>
      </div>
    </nav>
  );
};

export default SideNav;
